import type { BlockCMS } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { Tab } from '@headlessui/react'
import { Fragment, useState } from 'react'
import ImageOptimize from '../ImageOptimize'
import ProductCard from '../ProductCard'
interface ModuleProductTabType {
  data: BlockCMS
  order: number
}
const ModuleProductTab = ({ data, order }: ModuleProductTabType) => {
  const bgColorArray = data.data.map(e => e?.color)
  const [selectedIndex, setSelectedIndex] = useState(0)
  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'}  ${
        'order-[' + (order + 1) + ']'
      } relative mt-3 scroll-mt-[158px]`}
    >
      <Tab.Group
        as='div'
        onChange={setSelectedIndex}
        selectedIndex={selectedIndex}
        className={`relative `}
      >
        <Tab.List
          as='div'
          className={`scrollbar-track-transparent relative z-10 mx-3 max-w-[calc(100%-32px)] overflow-x-auto pb-2`}
        >
          <div className='flex w-max gap-2.5'>
            {data &&
              data.data.map((list, idx) => {
                return (
                  <Tab as={Fragment} key={idx}>
                    {({ selected }) => (
                      <button
                        className={`flex h-[86px] w-[120px] flex-col flex-wrap items-center justify-center gap-1 text-xs outline-0 focus:outline-0 ${
                          selected
                            ? ' bg-red-600 font-bold text-white'
                            : 'text-black bg-white'
                        } relative rounded shadow `}
                      >
                        <ImageOptimize
                          src={selected ? list.activeImage : list.image || ''}
                          alt={getTranslate(list.name)}
                          width={40}
                          height={40}
                          className='mb-0.5 h-5 w-5 object-contain'
                        />
                        {selected && (
                          <div className='absolute bottom-[-10px] h-0 w-0 border-x-8 border-t-[10px] border-x-transparent border-t-red-600'></div>
                        )}
                        <span> {getTranslate(list.name)}</span>
                      </button>
                    )}
                  </Tab>
                )
              })}
          </div>
        </Tab.List>
        <Tab.Panels
          as='div'
          className={`min-h-[400px] rounded-lg px-3 pb-4 pt-[72px] ${
            data.data.length > 8 ? 'mt-[-60px]' : 'mt-[-50px]'
          }`}
          style={{ backgroundColor: bgColorArray[selectedIndex] }}
        >
          {data &&
            data.data.map((list, idx) => {
              return (
                <Tab.Panel key={idx}>
                  <div className='products grid grid-cols-4 gap-3'>
                    {list.products.map(item => (
                      <ProductCard product={item} key={item._id} />
                    ))}
                  </div>
                </Tab.Panel>
              )
            })}
        </Tab.Panels>
      </Tab.Group>
    </section>
  )
}

export default ModuleProductTab
